<template>

	<v-content>
		<v-container fluid>

			<v-layout row wrap v-show="pageMajorStep == 'subdomainlist'">
				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-text-field flat solo-inverted hide-details prepend-inner-icon="search"
								label="Domain Ara" v-model="subdomainfilter"></v-text-field>
							<v-btn icon @click="goPageMajorToNewsubdomian()">
								<v-icon>add_circle</v-icon>
							</v-btn>
						</v-toolbar>

						<v-list two-line>
							<template v-if="subdomainlistloading">
								<div class="text-xs-center pa-5">
									<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
									<div class="caption mt-4">Subdomain listesi yükleniyor</div>
								</div>
							</template>
							<template v-for="(subdomain, subdomainIndex) in getSubdomainList">
 
								<v-list-tile  v-if="subdomain.sitedomain" :key="subdomainIndex" avatar @click="doOpenSubdomainDetails(subdomain)">
									<v-list-tile-avatar>
										<img src="@/assets/robot.png">
									</v-list-tile-avatar>

									<v-list-tile-content> 
										<v-list-tile-title v-html="subdomain.sitedomain"></v-list-tile-title>
										<v-list-tile-sub-title v-html="subdomain.domain"></v-list-tile-sub-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					</v-card>
				</v-flex>
			</v-layout> 


			<v-layout row wrap v-show="pageMajorStep == 'newsubdomain'">
				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-btn icon @click="goPageMajorToSubdomainlist()">
								<v-icon>arrow_back_ios</v-icon>
							</v-btn>

							<v-toolbar-title>Yeni Subdomain Kur</v-toolbar-title>
						</v-toolbar>
						
						<template v-if="newsubdomain.step == 'select_domain'">
							<template v-if="domainlistloading">
								<div class="text-xs-center pa-5">
									<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
									<div class="caption mt-4">Domain listesi yükleniyor</div>
								</div>
							</template>
							<v-autocomplete v-model="newsubdomain.selected_domain"  :items="domainlist"  
								cache-items class="ma-3" flat hide-no-data hide-details
								label="Sitenin kalıcı domain adresi." solo-inverted  >
							</v-autocomplete>
							<v-layout row justify-space-between class=" mr-2 ml-2 pb-3">
								<v-flex xs6>
									<v-btn color="warning" @click="newsubdomain.step = 'select_domain'">Domain Yönetimine Git</v-btn>
								</v-flex> 
								<v-flex xs6 class="text-xs-right">
									<v-btn color="info" @click="goPageMinorNewsubdomainFolder()">Sonraki Adım </v-btn>
								</v-flex> 
							</v-layout> 
						</template>
						<template v-if="newsubdomain.step == 'enter_subdomain_name'">
							<v-text-field :label="'Subdomain Adresi ('+newsubdomain.selected_domain+')'" v-model="newsubdomain.folder" suffix=".ajans360.net"
								class="ml-3 mt-3 mr-3 mb-0" outline></v-text-field>
  
							<v-layout row justify-space-between class=" mr-2 ml-2 pb-3">
								<v-flex xs6>
									<v-btn color="info" @click="newsubdomain.step = 'select_domain'">Geri</v-btn>
								</v-flex> 
								<v-flex xs6 class="text-xs-right">
								<v-btn color="success"
									@click="goPageMinorNewsubdomainSetup()">
									Kurulumu Başlat
									<v-icon right dark>cloud_upload</v-icon>
								</v-btn>
								</v-flex> 
							</v-layout> 
 
						</template>

						
						<template v-if="newsubdomain.step == 'setup'">
							<div class="text-xs-center pa-5">
								<v-progress-circular :rotate="-90" :size="100" :width="8" :value="newsubdomaininstalling.percent" :indeterminate="newsubdomaininstalling.step == 0" color="success">
									{{newsubdomaininstalling.percent}}%
								</v-progress-circular>
								<div class="caption mt-4">{{newsubdomaininstalling.text}}</div>
								
								<v-btn color="success"
									v-show="onErrorOnSetup"
									@click="goPageMinorNewsubdomainSetup()">
									Tekrar Dene 
								</v-btn>

							</div>
						</template>
					</v-card>
				</v-flex>
			</v-layout>


			<v-layout row wrap v-show="pageMajorStep == 'subdomaindetail'">
				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-btn icon @click="goPageMajorToSubdomainlist()">
								<v-icon>arrow_back_ios</v-icon>
							</v-btn>

							<v-toolbar-title>{{subdomaindetails.domain}}</v-toolbar-title>
						</v-toolbar>

							<AuthViewForDomains v-if="pageMajorStep == 'subdomaindetail'" :domain="subdomaindetails.domain" class=" pb-3 pt-4" /> 

							<v-layout row justify-space-between class=" mr-2 ml-2 pb-3 pt-3">
								<v-flex xs6>
									<v-btn 
									color="error" 
									:loading="subdomainRemoving" 
									@click="doSubdomainRemoveAsk()"
									>Sil</v-btn>
								</v-flex> 
								<v-flex xs6 class="text-xs-right">
								<v-btn color="success"
									:loading="subdomainMoving"
									@click="doSubdomainMove()">
									Siteyi Taşı
									<v-icon right dark>send</v-icon>
								</v-btn>
								</v-flex> 
							</v-layout> 
					</v-card>
				</v-flex>
			</v-layout>

			<v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" top color="success" > 
				{{ snackbar.text }} 
				<v-btn color="white" flat @click="snackbar.show = false" > Tamam </v-btn> 
			</v-snackbar>

			<v-dialog v-model="subdomainRemoveDialog" max-width="380">
				<v-card>
					<v-card-title class="headline">Silmek istediğine emin misin ?</v-card-title> 
					<v-card-actions>
						<v-spacer></v-spacer> 
						<v-btn color="warning" flat="flat" @click="subdomainRemoveDialog = false"> VAZGEÇ </v-btn> 
						<v-btn color="error" @click="doSubdomainRemove()"> EMİNİM </v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

		</v-container>
	</v-content>


</template>


<script>
	import AuthViewForDomains from "@/components/tools/AuthViewForDomains"

	export default {
		name: "WebNetminSubdomains",
		components:{
			AuthViewForDomains
		},
		data() {
			return {

				subdomainlist : [],
				subdomainlistloading : false,
				subdomainfilter : "",

				domainlist : [],
				domainlistloading : false,

				pageMajorStep : null,

				newsubdomain : {
					step : 'select_domain',
					selected_domain : "",
					folder : "",
					force : "",
					status : "waiting", 
					progress : 0,
					reason  : "Kurulum başlıyor "
				},
				newsubdomaininstalling : { step : 0, totalstep : 0, percent : 0, text : "", success : true  },
				onErrorOnSetup : true,

				subdomaindetails : {},
				subdomainMoving : false,
				subdomainRemoving : false,
				subdomainRemoveDialog : false,

				dialogNewAccount: false,

				snackbar : {
					timeout : 4000,
					text : "",
					show : false
				}

			}
		},
		watch: {
			loader() {
				const l = this.loader
				this[l] = !this[l]

				setTimeout(() => (this[l] = false), 3000)

				this.loader = null
			}
		},
		mounted(){
			this.goPageMajorToSubdomainlist();
		},
		methods:{
			goPageMajorToSubdomainlist(){
				this.doGetSubdomainList();
				this.pageMajorStep = 'subdomainlist';
			},
			goPageMajorToNewsubdomian(){
				this.pageMajorStep = 'newsubdomain';
				this.newsubdomain.step == 'select_domain'
				this.doGetDomainList();
			},
			goPageMinorNewsubdomainFolder(){
				var parts = this.newsubdomain.selected_domain.split(".");
				if(parts.length){
					this.newsubdomain.folder = parts[0]
				}
				this.newsubdomain.step = 'enter_subdomain_name'
			}, 
			goPageMinorNewsubdomainSetup(){ 
				this.onErrorOnSetup = false;
				this.newsubdomaininstalling = { step : 0, totalstep : 0, percent : 0, text : "", success : true  };
				var self = this;
				self.newsubdomain.step = 'setup' 
				var es = new EventSource(process.env.VUE_APP_API_URL + '/web/netmin/setup/?domain='+self.newsubdomain.selected_domain+'&folder='+self.newsubdomain.folder); 
				es.addEventListener('message', (e) => {
					var result = JSON.parse( e.data );
					
					self.newsubdomain.status = result.status

					Object.keys(result).forEach( (key) => {
						self.newsubdomaininstalling[key] = result[key]
					});
					self.newsubdomaininstalling.percent = parseInt( self.newsubdomaininstalling.step * 100 / self.newsubdomaininstalling.totalstep );
	 				if(!self.newsubdomaininstalling.success){
						this.onErrorOnSetup = true;
					}
				});
				
				es.addEventListener('error', function(e) { 
					es.close();
				});
			},
			doGetSubdomainList(){ 
				this.subdomainlistloading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/web/netmin/subdomains" ).then(response => { 
					if(response.body.success){
						this.subdomainlist = response.body.data
						this.subdomainlistloading = false; 
					}
				}) 
			},
			doGetDomainList(){ 
				if(this.domainlist.length > 0){ return true; }
				this.domainlistloading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/server/domains/justdomains" ).then(response => { 
					this.domainlist = response.body;
					this.domainlistloading = false; 
				}) 
			},

			SubdomainSetupStart(){

			},

			doOpenSubdomainDetails(subdomain){
				this.subdomaindetails = subdomain;
				this.pageMajorStep = 'subdomaindetail'
				this.subdomainMoving = false;
				this.subdomainRemoving = false;
			},
			doSubdomainMove(){
				this.subdomainMoving = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/web/netmin/subdomains/transfer/", {
					params: {
						domain: this.subdomaindetails.sitedomain,
						folder: this.subdomaindetails.folder
					}
				}).then(response => {
					this.subdomainMoving = false;
					this.snackbar.show = true;
					this.snackbar.text = "Subdomain ana siteye taşındı"; 
				})
			},
			doSubdomainRemoveAsk(){
				this.subdomainRemoveDialog = true;
			},
			doSubdomainRemove(){
				this.subdomainRemoveDialog = false;
				this.subdomainRemoving = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/web/netmin/subdomains/remove/", {
					params: {
						domain: this.subdomaindetails.sitedomain,
						folder: this.subdomaindetails.folder
					}
				}).then(response => {
					this.subdomainRemoving = false;
					this.snackbar.show = true;
					this.snackbar.text = "Subdomain silindi"; 
					this.goPageMajorToSubdomainlist();
				})
			},
		},
		computed:{
			getSubdomainList(){
				var list = [];
				var filter = this.subdomainfilter.toLowerCase();
				
				
				for(var i in this.subdomainlist){
					var e = this.subdomainlist[i];
					if(filter == ""){ 
						list.push(e);
					} 
					else{ 
						if(e.domain.includes(filter)  || ('sitedomain' in e && e.sitedomain.includes(filter))   ){
							list.push(e);
						}
					}
				} 
				return list;
			}
		}
	}
</script>